












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePartenaire from '@/components/partenaire/edit/EditBasePartenaire.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { toSubArray } from '@/utils/groupBy'
import { getDefaultAloPartenaire, AloPartenaire } from '@/models/alo/AloPartenaire'

@Component({
  name: 'EditFlux',    
  components:{EditBasePartenaire}
})
export default class EditFlux extends Vue {
  
  private partenaire = getDefaultAloPartenaire()
  
  edit(item:AloPartenaire) {    
    this.partenaire = (this.$refs.baseEdit as EditBasePartenaire).edit(item)
  }  

  get fluxList() {
    //@ts-ignore    
    return this.$store.myGetters.fluxList
  }

  get fluxGroup(){
    return toSubArray(this.fluxList,3)
  }
}
